package er.prateek.crossly.notifications

/**
 * Which "why are we nudging you" story a scheduled reminder tells, in priority order --
 * [NotificationCoordinator] picks the first one that applies. Kept as data rather than a
 * hardcoded string pair so analytics (`notification_scheduled`, `notification_tapped`) can key
 * off [ReminderVariant] directly instead of parsing copy.
 */
enum class ReminderVariant {
    /** The streak already broke but can still be restored -- a last call before it's gone for good. */
    STREAK_RESTORE,

    /** Has an active streak and hasn't played today -- the highest-stakes nudge. */
    STREAK_AT_RISK,

    /** No streak at risk, but today's daily challenge is still unplayed. */
    DAILY_CHALLENGE_AVAILABLE,

    /** Neither of the above -- a plain "come back and play" for a lapsed or new player. */
    REENGAGEMENT,
}

/**
 * A reminder's resolved copy. [title]/[body] are already localized `stringResource` output --
 * platform schedulers never do resource lookups themselves, see [LocalNotificationScheduler].
 */
data class ReminderContent(
    val variant: ReminderVariant,
    val title: String,
    val body: String,
)
